<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="OT" id="_idParaDest-3"><a href="#/Stewart_Envisioning_the_Congregation_text_CC3#toc2"></a><a id="_idTOCAnchor-3"></a>Acknowledgments</p>
<p class="BODYFLUSH">This book would have been inconceivable without the encouragement and contributions of friends and colleagues. I owe them an enormous debt of gratitude. Even the following list is incomplete: Eileen Best, Linda Bieze, Laurence Bratschie, Robert and Betty Coughenour, Clinton and Cathy Cozier, Jerry and Janet Diggins, Wes Granberg-­Michaelson, P. Douglas and Barbara Kindschi, Daniel L. and Margaret Migliore, Donald and Bethany Gordon, the late Marian Randlett Glover, Olivia Stewart Robertson, Richard R. and Sally Osmer, E. Stanley Ott, Brian Phillips, Jon Pott, Phillip J. Reed, Jack Roeda, Allen D. Timm, Carolyn Timmer, John Witvliet.</p>
<p class="BODY-T1">As will become apparent, I have relied on a select group of scholars from whom I have learned — and lifted! — much. Notable among these are Nancy Ammerman, Mark Chaves, Kenda Creasy Dean, Daniel L. Migliore, Jürgen Moltmann, Richard R. Osmer, Marjorie J. Thompson, Geoffrey Wainwright, Nicholas Wolterstorff, and Robert Wuthnow. Just beneath the surface here are my former mentors at the University of Michigan, including the late Timothy L. Smith, James C. Turner, and especially the late John Higham, who urged his students to “join historical scholarship with contemporary social concern.” These historians of American culture shaped my understanding of the ways Protestant churches intersect with American society.</p>
<p class="BODY">My wife, Maureen Stewart, is not only my best friend but she is also my most trusted consultant and editor. Her steady encouragement has never waned. She deserves far more of my gratitude than I am able to express.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Stewart_Envisioning_the_Congregation_text_CC5.vue?347b2ce7